import { useInvertedButton } from './useInvertedButton';
import { useInvertedColor } from './useInvertedColor';
import useTheme from './useTheme';

export { useTheme, useInvertedButton, useInvertedColor };

export default useTheme;
